export default __webpack_public_path__ + "static/media/trend-negative.3b38d4b9.svg";